import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { getBankAccount } from './mapper/getBankAccount';
import { getBanks } from './mapper/getBanks';

export const infoQueryKey = createQueryKeys('info', {
  bankAccount: {
    queryFn: async () => {
      const data = await getBankAccount();
      return data;
    },
    queryKey: null,
  },
  banks: {
    queryFn: async () => {
      const data = await getBanks();
      return data;
    },
    queryKey: null,
  },
});

export type InfoQueryKey = inferQueryKeys<typeof infoQueryKey>;
